<!-- 
TagInfoModal.vue
功能：客戶標籤定義視窗
作者：i9400538 陳博承
完成：2021-04-09
-->
<template>
  <div id="tag-info-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="float-left w-75 pr-3">
            <h2 class="mb-line text-green mt-0 mb-0">{{def.function_name || '客戶標籤'}}</h2>
            <div>
              <span
                class="font-weight-bold mr-2"
              >{{def.description || '透過客戶標籤快速瞭解您的客戶 增加您的接觸話題與接觸機會!!!'}}</span>
            </div>
          </div>
          <div class="float-left w-25">
            <div class="mb-line">
              <span class="font-weight-bold mr-2">維護單位</span>
              <span>{{def.dev_name || '客戶智能科'}}</span>
            </div>
            <div class="mb-line">
              <span class="font-weight-bold mr-2">聯絡電話</span>
              <span>{{def.contact || '(02)27551399'}}</span>
            </div>
            <div class="mb-line">
              <span class="font-weight-bold mr-2">聯絡分機</span>
              <span>{{def.contact_tel || '7115'}}</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="insurance-row row">
            <table id="tag-info-table" class="table datatable insurance-green">
              <thead>
                <tr>
                  <th width="140">標籤名稱</th>
                  <th width="*">定義</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tag, i) in data" :key="`tag-info-${i}`">
                  <td>{{tag.tag_show_name || tag.tag_name}}</td>
                  <td v-html="tag.tag_agdef"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "TagInfoModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    def: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        this.data.map(item => {
          item.tag_agdef = item.tag_agdef.replace(/\n|\r\n/g, "<br>");
        });
        this.registerHanlink(); // for hard word
      }
    }
  }
};
</script>
